import { IPolicyEmailComposeState } from "./policyEmailCompose.types";

export const initialPolicyEmailComposeState: IPolicyEmailComposeState = {
  panelOpen: false,
  customerId: null,
  producerCode: null,
  recipientEmails: [],
  recipientLoading: false,
  producerEmail: null,
  producerEmailLoading: false,
  sendingEmail: false,
  error: null,
};
